import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, Input, OnInit, Output,
  inject
} from '@angular/core';
import { ServiceSubscription } from 'taxtank-core';
import { BaseComponent } from '@shared/component/base/base.component';
import { PipeModule } from '@shared/pipe/pipe.module';

/**
 * Stripe promo code information component
 */
@Component({
  selector: 'app-promo-code',
  templateUrl: './promo-code.component.html',
  styleUrls: ['./promo-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PipeModule],
})
export class PromoCodeComponent extends BaseComponent implements OnInit {
  @Input() subscription: ServiceSubscription;
  @Output() removed: EventEmitter<void> = new EventEmitter();

  private cd = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.cd.detectChanges();
  }
}
